import { Tab } from '@mui/material';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeader, QueryTabs, QueryTabPanel } from 'components';
import { TranslationNamespace } from 'i18n';

import { BlockedCustomersList } from './BlockedCustomersList';

enum Tabs {
  Active = 'active',
  Archive = 'archive',
}

export const BlockedCustomersPage: React.FC = () => {
  const { t: tLayout } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'layout',
  });
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features.blocked_customers',
  });

  return (
    <Fragment>
      <PageHeader title={tLayout('menu_items.customers')} divider={false} />
      <QueryTabs tabsEnum={Tabs}>
        <Tab value={Tabs.Active} label={t('tabs.active')} />
        <Tab value={Tabs.Archive} label={t('tabs.archive')} />
      </QueryTabs>
      <QueryTabPanel value={Tabs.Active}>
        <BlockedCustomersList />
      </QueryTabPanel>
      <QueryTabPanel value={Tabs.Archive}>
        <BlockedCustomersList archived />
      </QueryTabPanel>
    </Fragment>
  );
};
